export default {"src":"https://fishbrain.com/_next/static/media/drum.fa5526b6.svg","height":115,"width":230,"blurWidth":0,"blurHeight":0};